import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Currency } from '@app/graphql-typings/graphql';
import { CountryAndTimezoneService } from '@shared/services/country-timezone/country-and-timezone.service';


export enum CurrencyDisplayFormat {
  CODE = 'code',
  SYMBOL = 'symbol',
  SYMBOL_NARROW = 'symbol-narrow',
}


@Component({
  selector: 'app-ace-currency',
  templateUrl: './ace-currency.component.html',
  styleUrls: ['./ace-currency.component.scss'],
  standalone: false
})
export class AceCurrencyComponent implements OnChanges {

  private readonly DEFAULT_DISPLAY_FORMAT = CurrencyDisplayFormat.SYMBOL;
  private readonly DEFAULT_MIN_INTEGER_DIGITS = 1;
  private readonly DEFAULT_MIN_FRACTION_DIGITS = 2;
  private readonly DEFAULT_MAX_FRACTION_DIGITS = 2;

  @Input() currency: Currency;
  @Input() value: number;
  @Input() displayFormat: CurrencyDisplayFormat | string = this.DEFAULT_DISPLAY_FORMAT;
  @Input() minIntegerDigits = this.DEFAULT_MIN_INTEGER_DIGITS;
  @Input() minFractionDigits = this.DEFAULT_MIN_FRACTION_DIGITS;
  @Input() maxFractionDigits = this.DEFAULT_MAX_FRACTION_DIGITS;

  currencyCode: string;
  digitsInfo: string;

  constructor(private countryAndTimezoneService: CountryAndTimezoneService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currency) {
      this.currencyCode = this.currency ? this.countryAndTimezoneService.getCurrencyCode(this.currency) : null;
    }
    if (changes.displayFormat && this.displayFormat == null) {
      this.displayFormat = CurrencyDisplayFormat.SYMBOL;
    }
    if (changes.minIntegerDigits || changes.minFractionDigits || changes.maxFractionDigits) {
      this.digitsInfo =
          (this.minIntegerDigits != null ? this.minIntegerDigits : this.DEFAULT_MIN_INTEGER_DIGITS)
          + '.' + (this.minFractionDigits != null ? this.minFractionDigits : this.DEFAULT_MIN_FRACTION_DIGITS)
          + '-' + (this.maxFractionDigits != null ? this.maxFractionDigits : this.DEFAULT_MAX_FRACTION_DIGITS);
    }
  }

}
